import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import { extendObservable, intercept, observe } from 'mobx'
import styled, { keyframes } from 'styled-components'
import { TweenMax } from 'gsap'
import LockWhiteIcon from '@/assets/images/icon-lock-white.svg'
import ReactQuill, { Quill } from 'react-quill'
import 'react-quill/dist/quill.snow.css'
import DDAnnounceSponsor from '@/Components/CommandHost/Common/DDAnnounceSponsor'
import CheckIcon from '@/assets/images/play-resolved.svg'
import { vhToPx, evalImage } from '@/utils'
import { responsiveDimension } from '../../utils'

@inject('PrePlayStore', 'CommandHostStore', 'GameStore', 'AutomationStore')
@observer
export default class AnnounceItemResolved extends Component {
  constructor(props) {
    super(props)
    this.state = {
      reusedPlay: null,
      reusedNewPlayIndex: -1,
    }
    FONT_SIZE = this.props.CommandHostStore.fontSize + 'vh'
    extendObservable(this, {
      promptRemove: false,
      quillHeader: null,
      quillMiddle: null,
      quillBottom: null,
      sessionStarted: this.props.GameStore.isSessionStarted,
    })

    this.reference = `announce-editor-resolved-${this.props.item.id}`

    this.destroySessionMode = intercept(
      this.props.GameStore,
      'sessionMode',
      change => {
        this.sessionStarted = change.newValue === 1
        this.forceUpdate()
        return change
      }
    )
    this.disposeReuse = observe(this.props.GameStore, 'reusedPlay', change => {
      if (change.newValue) {
        setTimeout(() => {
          this.setState({ reusedPlay: change.newValue })
        }, 0)
      }
      return change
    })
    this.disposeReusedUniqueId = observe(
      this.props.GameStore,
      'reusedUniqueId',
      change => {
        if (change.newValue) {
          setTimeout(() => {
            this.setState({ reusedUniqueId: change.newValue })
          }, 0)
        }
        return change
      }
    )
    this.disposeReusePlayIndex = observe(
      this.props.PrePlayStore,
      'preplayItems',
      change => {
        if (change.newValue) {
          setTimeout(() => {
            this.setState({ reusedNewPlayIndex: change.newValue })
          }, 0)
        }
        return change
      }
    )
  }

  handleReuseButtonClick(refId) {
    this.props.AutomationStore.addEvent({
      evt: 'click',
      refId: refId,
      wait: 0.5,
      playId: this.props.item.id,
    })

    // document.body.scrollTop = 0
    // document.documentElement.scrollTop = 0

    //this.props.CommandHostStore.setReusePlay(this.props.item)
    let play = this.props.item
    if (!play) return
    play.pmetadata = play.pmetadata
      ? {
          timerInput: play.pmetadata.timerInput,
        }
      : {}
    this.props.reuse(play)
  }

  handleEndAnnounceClick(refId) {
    let { PrePlayStore } = this.props

    this.props.AutomationStore.addEvent({
      evt: 'click',
      refId: refId,
      wait: 1,
      playId: this.props.item.id,
    })
    if (PrePlayStore.nextPlayItem && PrePlayStore.nextPlayItem.id) {
      this.props.AutomationStore.addEvent({
        evt: 'click',
        refId: `go-button-${PrePlayStore.nextPlayItem.type}-${PrePlayStore.nextPlayItem.id}`,
        wait: 1,
        playId: PrePlayStore.nextPlayItem.id,
        isPreviousPlayEnded: true,
      })
    }

    this.props.endAnnouncement(this.props.item)
  }

  handleSelectedSponsor(val, isAutomatic) {
    if (!this.props.item.pmetadata) this.props.item.pmetadata = {}
    if (!this.props.item.pmetadata.public) this.props.item.pmetadata.public = {}

    if (isAutomatic === 'Undo') {
      this.props.item.pmetadata.public.isManualOverride = false
    } else {
      this.props.item.pmetadata.public.isManualOverride = true
    }

    this.props.item.sponsor = val
    this.props.item.sponsorExpanded = false
    if (!val) {
      this.sponsorEnable(0, false)
    }

    this.forceUpdate()
  }

  sponsorEnable(val, isExpanded) {
    if (val === 1) {
      const bottomEditorReadOnly = document.getElementsByClassName(
        `${this.reference}-bottom-readonly`
      )
      const bottomEditor = document.getElementsByClassName(
        `${this.reference}-bottom`
      )
      const bottomSponsor = document.getElementsByClassName(
        `${this.reference}-sponsor`
      )
      if (bottomEditorReadOnly && bottomEditor && bottomSponsor) {
        TweenMax.set(bottomEditorReadOnly, { display: 'none' })
        TweenMax.set(bottomEditor, { display: 'none' })
        TweenMax.set(bottomSponsor, { display: 'block' })
        this.props.item.sponsorExpanded = isExpanded
      }
    } else {
      const bottomEditorReadOnly = document.getElementsByClassName(
        `${this.reference}-bottom-readonly`
      )
      const bottomEditor = document.getElementsByClassName(
        `${this.reference}-bottom`
      )
      const bottomSponsor = document.getElementsByClassName(
        `${this.reference}-sponsor`
      )
      if (bottomEditorReadOnly && bottomEditor && bottomSponsor) {
        // TweenMax.set(bottomEditorReadOnly, { display: 'flex' })
        TweenMax.set(bottomEditor, { display: 'none' })
        // TweenMax.set(bottomSponsor, { display: 'none' })
      }
    }
  }

  toggleEditor(area, mode, editor, editorReadOnly) {
    if (mode === 'editing') {
      const e = document.getElementsByClassName(editor)
      const ero = document.getElementsByClassName(editorReadOnly)
      TweenMax.set(e, { display: 'block' })
      TweenMax.set(ero, { display: 'none' })
    } else {
      const e = document.getElementsByClassName(editor)
      const ero = document.getElementsByClassName(editorReadOnly)
      TweenMax.set(e, { display: 'none' })
      TweenMax.set(ero, { display: 'flex' })

      setTimeout(() => {
        if (area === 'header') {
          this.props.item.announcements[0].value = this.quillHeader.root.innerHTML
          ero[0].innerHTML = this.quillHeader.root.innerHTML
        }
        if (area === 'middle') {
          this.props.item.announcements[1].value = this.quillMiddle.root.innerHTML
          ero[0].innerHTML = this.quillMiddle.root.innerHTML
        }
        if (area === 'bottom') {
          this.props.item.announcements[2].value = this.quillBottom.root.innerHTML
          ero[0].innerHTML = this.quillBottom.root.innerHTML
        }
      }, 0)
    }
  }

  initValues() {
    const { item } = this.props
    const isGMAnnounce = this.isGmAnnouncement(item)
    let bottomValue = ''
    if (isGMAnnounce) {
      const videoInfo =
        item.announcements[2].value.match(/{[^{}]*}/) &&
        item.announcements[2].value.match(/{[^{}]*}/)[0]
      this.parsedVideoInfo = JSON.parse(videoInfo)
      bottomValue = item.announcements[2].value.replace(videoInfo, '')
    }
    document.getElementsByClassName(
      `${this.reference}-header-readonly`
    )[0].innerHTML = this.props.item.announcements[0].value
    document.getElementsByClassName(
      `${this.reference}-middle-readonly`
    )[0].innerHTML = this.props.item.announcements[1].value
    document.getElementsByClassName(
      `${this.reference}-bottom-readonly`
    )[0].innerHTML = this.props.item.announcements[2].value

    this.quillHeader.root.innerHTML = this.props.item.announcements[0].value
    this.quillMiddle.root.innerHTML = this.props.item.announcements[1].value
    this.quillBottom.root.innerHTML = this.props.item.announcements[2].value
  }

  isGmAnnouncement(item) {
    return item.subType && item.subType.includes('gm_announce')
  }

  gMAnnouncePlayTitle(item, index) {
    let title =
      item && item.subType && item.subType.includes('msg')
        ? 'MES VID'
        : 'GM MES'
    return title.split(' ')[index]
  }

  getPresetName(item) {
    const parser = new DOMParser()
    let videoInfo =
      item.announcements[2].value.match(/{[^{}]*}/) &&
      item.announcements[2].value.match(/{[^{}]*}/)[0]
    this.parsedVideoInfo = JSON.parse(videoInfo)
    return this.parsedVideoInfo && this.parsedVideoInfo.name
  }

  resetSuccessReUseState() {
    setTimeout(() => {
      this.setState({ reusedPlay: null })
      this.props.GameStore.reusedPlay = null
    }, 2000)
  }

  componentWillUnmount() {
    this.destroySessionMode()
    this.disposeReuse()
    this.disposeReusedUniqueId()
    this.disposeReusePlayIndex()
  }

  componentDidMount() {
    try {
      let Font = Quill.import('formats/font')
      Font.whitelist = [
        'pamainlight',
        'pamainregular',
        'pamainbold',
        'pamainextrabold',
      ]
      Quill.register(Font, true)

      this.quillHeader = new Quill(`.${this.reference}-header`, {
        modules: {
          toolbar: false,
        },
        theme: 'snow',
      })

      this.quillMiddle = new Quill(`.${this.reference}-middle`, {
        modules: {
          toolbar: false,
        },
        theme: 'snow',
      })

      this.quillBottom = new Quill(`.${this.reference}-bottom`, {
        modules: {
          toolbar: false,
        },
        theme: 'snow',
      })

      this.initValues()

      // old
      // if (this.props.item.sponsor && this.props.item.sponsor.id) {
      //   this.sponsorEnable(1, false)
      // } else {
      //   this.sponsorEnable(0, false)
      // }

      if (
        this.props.item.sponsor &&
        this.props.item.sponsor.sponsorCategory &&
        this.props.item.sponsor.sponsorItem &&
        this.props.item.sponsor.sponsorItem.brandId
      ) {
        this.sponsorEnable(1, false)
      } else {
        this.sponsorEnable(0, false)
      }
    } catch (err) {
      console.error('Sportoco - HostCommand Error: ', err)
    }
  }

  shouldComponentUpdate(nextState) {
    if (this.state.reusedPlay !== nextState.reusedPlay) return true
    if (this.state.reusedNewPlayIndex !== nextState.reusedNewPlayIndex)
      return true
    return false
  }

  render() {
    let { item, index } = this.props
    if (!item) return null
    let required = true
    let locked = true
    const isButtonLocked = !this.sessionStarted
    const isGMAnnounce = this.isGmAnnouncement(item)
    const presetName = isGMAnnounce ? this.getPresetName(item) : ''

    return (
      <Container zIndex={1000 - index}>
        <Wrapper>
          <Main>
            <ResolvedIcon />
            <PlayTypeDD>
              <PrePlaySequence
                backgroundColor={isGMAnnounce ? '#19d1bf' : '#231f20'}
                text={`${item.sequence}`}
              />
              {isGMAnnounce ? (
                <PrePlaySingle backgroundColor={'#19d1bf'}>
                  <span
                    style={{ whiteSpace: 'break-spaces' }}
                  >{`${this.gMAnnouncePlayTitle(item, 0)} `}</span>
                  <span
                    style={{
                      color: ['MES'].includes(this.gMAnnouncePlayTitle(item, 1))
                        ? '#C61818'
                        : '#fff',
                    }}
                  >{`${this.gMAnnouncePlayTitle(item, 1)}`}</span>
                </PrePlaySingle>
              ) : (
                <PrePlaySingle
                  text={`${
                    item.type.toLowerCase() === 'announce' ? 'anoc' : item.type
                  }`}
                  backgroundColor={'#231f20'}
                />
              )}
            </PlayTypeDD>
            <InputsWrapper>
              <Row>
                {isGMAnnounce && (
                  <SelectTypeLocked title={presetName}>
                    {presetName}
                  </SelectTypeLocked>
                )}
                <RowArea key={0}>
                  <EditorReadOnly
                    locked
                    className={`${this.reference}-header-readonly`}
                    onClick={
                      locked
                        ? null
                        : this.toggleEditor.bind(
                            this,
                            'header',
                            'editing',
                            `${this.reference}-header`,
                            `${this.reference}-header-readonly`
                          )
                    }
                    isGMAnnounce={isGMAnnounce}
                    isLineHeight={true}
                  />
                  <Editor
                    id="announce-editor"
                    className={`${this.reference}-header`}
                    onBlur={this.toggleEditor.bind(
                      this,
                      'header',
                      'locking',
                      `${this.reference}-header`,
                      `${this.reference}-header-readonly`
                    )}
                  />
                </RowArea>
                <RowArea key={1}>
                  <EditorReadOnly
                    locked
                    className={`${this.reference}-middle-readonly`}
                    onClick={
                      locked
                        ? null
                        : this.toggleEditor.bind(
                            this,
                            'middle',
                            'editing',
                            `${this.reference}-middle`,
                            `${this.reference}-middle-readonly`
                          )
                    }
                    isLineHeight={true}
                    mLeft={0.2}
                  />
                  <Editor
                    id="announce-editor"
                    className={`${this.reference}-middle`}
                    onBlur={this.toggleEditor.bind(
                      this,
                      'middle',
                      'locking',
                      `${this.reference}-middle`,
                      `${this.reference}-middle-readonly`
                    )}
                  />
                </RowArea>
                <RowArea key={2} width={'40%'}>
                  <EditorReadOnly
                    locked
                    className={`${this.reference}-bottom-readonly`}
                    onClick={
                      locked
                        ? null
                        : this.toggleEditor.bind(
                            this,
                            'bottom',
                            'editing',
                            `${this.reference}-bottom`,
                            `${this.reference}-bottom-readonly`
                          )
                    }
                    style={{
                      display: 'none',
                    }}
                    mLeft={0.2}
                  />
                  <Editor
                    id="announce-editor"
                    className={`${this.reference}-bottom`}
                    onBlur={this.toggleEditor.bind(
                      this,
                      'bottom',
                      'locking',
                      `${this.reference}-bottom`,
                      `${this.reference}-bottom-readonly`
                    )}
                    style={{
                      display: 'none',
                    }}
                  />
                  <DDSponsorWrapper
                    className={`${this.reference}-sponsor`}
                    style={{
                      display: 'block',
                      marginLeft: '0.2vh',
                    }}
                  >
                    <DDAnnounceSponsor
                      locked
                      height={h}
                      index={`${this.reference}-sponsor`}
                      selectedSponsor={item.sponsor}
                      value={this.handleSelectedSponsor.bind(this)}
                      expanded={item.sponsorExpanded}
                      isAnnouncementAfterActive={true}
                      subType={item ? item.subType : null}
                      sponsorId={item.sponsorId}
                      sponsorMetaData={
                        item.sponsor ? item.sponsor.sponsorItem || null : null
                      }
                      pmetadata={
                        item.pmetadata ? item.pmetadata.public || null : null
                      }
                    />
                  </DDSponsorWrapper>
                </RowArea>
              </Row>
            </InputsWrapper>
            <ReuseButton
              locked={isButtonLocked}
              id={`${this.reference}-reuse-button`}
              onClick={
                isButtonLocked
                  ? null
                  : this.handleReuseButtonClick.bind(
                      this,
                      `${this.reference}-reuse-button`
                    )
              }
            >
              {this.state.reusedPlay === item.id &&
                this.state.reusedNewPlayIndex !== -1 && (
                  <ReUseSuccess
                    onAnimationEnd={e => {
                      e.stopPropagation()
                      this.resetSuccessReUseState()
                    }}
                  >
                    {'success'}
                  </ReUseSuccess>
                )}
            </ReuseButton>
          </Main>
        </Wrapper>
      </Container>
    )
  }
}

const h = 6
let FONT_SIZE = '1.8vh'

const Container = styled.div`
  width: 100%;
  height: ${props => h}vh;
  display: flex;
  flex-direction: column;
  opacity: 0;
  animation: ${props => fadeIn} 0.3s forwards;
  margin-top: ${props => 0.2}vh;
  z-index: ${props => props.zIndex};
`

const fadeIn = keyframes`
  0%{opacity: 0;}
  100%{opacity: 1}
`

const Wrapper = styled.div`
  width: inherit;
  height: inherit;
  display: flex;
  user-select: text;
`

const Main = styled.div`
  width: inherit;
  height: ${props => h}vh;
  display: flex;
  flex-direction: row;
  align-items: center;
  font-family: pamainbold;
  font-size: ${props => FONT_SIZE};
`

const ResolvedIcon = styled.div`
  width: 2.9%;
  height: 100%;
  background-color: #000000;
  &:after {
    width: 100%;
    height: 100%;
    content: '';
    display: inline-block;
    background-image: url(${CheckIcon});
    background-repeat: no-repeat;
    background-size: 50%;
    background-position: center;
  }
`

const PlayTypeDD = styled.div`
  width: 8.4%;
  height: ${props => h}vh;
  display: flex;
`
const PlayStatusWrapper = styled.div`
  width: 40%
  height: ${props => h}vh;
  background-color: #000000;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-image: url(${LockWhiteIcon});
  background-repeat: no-repeat;
  background-size: 50%;
  background-position: center;
`
const PrePlaySequence = styled.div`
  width: 40%;
  height: ${props => h}vh;
  background-color: ${props => props.backgroundColor};
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: pamainlight;
  font-size: ${props => FONT_SIZE};
  color: white;
  line-height: 1;
  border-right: 0.5px solid;
  &:after {
    content: '${props => props.text}';
  }
`

const PrePlaySingle = styled.div`
  width: 60%;
  height: ${props => h}vh;
  background-color: ${props => props.backgroundColor};
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: pamainbold;
  font-size: ${props => FONT_SIZE};
  color: white;
  line-height: 1;
  text-transform: uppercase;
  &:after {
    content: '${props => props.text}';
  }
`

const SelectTypeLocked = styled.div`
  width: auto;
  max-width: calc(50ch + 1vh);
  flex-shrink: 0;
  height: ${props => h}vh;
  background-color: #e5e5e5;
  font-family: pamainbold;
  font-size: ${props => FONT_SIZE};
  color: #000000;
  text-transform: uppercase;
  display: block;
  text-align: center;
  line-height: ${props => h}vh;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 0 0.5vh;
`

const InputsWrapper = styled.div`
  width: 85.4%;
  height: ${props => h}vh;
`

const Row = styled.div`
  width: 100%;
  height: inherit;
  display: flex;
  justify-content: space-between;
`

const RowArea = styled.div`
  width: ${props => props.width || '100%'};
  height: inherit;
  display: flex;
  flex-direction: row;
`

const Editor = styled.div`
  width: 100%;
  height: inherit;
  background-color: #ffffff;
  display: none;
`

const EditorReadOnly = styled.div`
  width: 100%;
  height: inherit;
  background-color: #ffffff;
  display: flex;
  padding: 0 10px;
  cursor: ${props => (props.locked ? 'default' : 'pointer')};
  margin-left: ${props => props.mLeft || ''}vh;
  text-transform: uppercase;
  font-family: ${props => (props.isGMAnnounce ? 'pamainbold' : 'pamainlight')};
  line-height: ${props => props.isLineHeight && 1.6};
  align-items: flex-start;
  overflow: auto;
  ms-overflow-style: ${'-ms-autohiding-scrollbar'};
  &::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 0.3vh rgba(0, 0, 0, 0.3);
    background-color: #f5f5f5;
    border-radius: ${props => 1}vh;
  }
  &::-webkit-scrollbar {
    width: ${props => responsiveDimension(0.4)};
    background-color: #f5f5f5;
  }
  &::-webkit-scrollbar-thumb {
    background-color: rgba(255, 0, 0, 0.6);
    &:hover {
      background-color: rgba(255, 0, 0, 1);
    }
    border-radius: ${props => 1}vh;
  }

  p {
    margin: auto 0;
  }
`

const LastButtonWrapper = styled.div`
  width: ${props => 20}vh;
  height: inherit;
  display: flex;
`

const EndAnnounceButton = styled.div`
  width: 100%;
  height: 100%;
  background-color: #c61818;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  &:after {
    content: 'END ANNOUNCEMENT';
    color: #ffffff;
  }
`

const DDSponsorWrapper = styled.div`
  width: 100%;
  position: relative;
  display: none;
`

const ReuseButton = styled.div`
  width: 5.2%;
  height: inherit;
  color: #18c5ff;
  background-color: #000000;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: ${props => (props.locked ? 'default' : 'pointer')};
  opacity: ${props => (props.locked ? 0.2 : 1)};
  &:before {
    content: 'REUSE';
    width: 70%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  &:after {
    width: 20%;
    height: 100%;
    content: '';
    background-image: url(${props => evalImage('reuse.svg')});
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: center;
  }
`

const ReUseSuccess = styled.div`
  width: 5.1%;
  height: ${h}vh;
  color: #fff;
  background-color: #0fbc1c;
  display: flex;
  justify-content: center;
  align-items: center;
  text-transform: uppercase;
  position: absolute;
  z-index: 101;
  animation: ${props => `${slideIn} 2s forwards`};
`

const slideIn = keyframes`
  0% { transform: translateX(100%); opacity: 0; }
  100% { 
    transform: translateX(0%); 
    opacity: 1;
  }
`

const Section = styled.div`
  width: 84%;
  height: 100%;
`



// WEBPACK FOOTER //
// src/Components/CommandHost/AnnounceItemResolved.js